export default __webpack_public_path__ + "static/media/01.5172b696.svg";